import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';

@Component({
  selector: 'app-startup-page',
  templateUrl: './startup-page.component.html',
  styleUrls: ['./startup-page.component.css'],
  animations: [slideInAnimation],
})
export class StartupPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
